// Who must use two-factor sign-in (CLAUDE.md: "2FA for admin and finance-approver roles";
// ADR 0037). A role needs it when its flag says so OR it holds any permission below, so an
// administrator can't build a role that changes access or approves money without it by
// leaving a box unticked. This is the only place the rule is defined: sign-in, every
// request (resolveAccess), the role API and the template test all use it.
//
// Provisional list (plan golive-onboarding-and-account-security.md §5, P4): the owner confirms.

import type { Permission } from './permissions.ts';

const LIST: readonly Permission[] = [
  // Administration that changes who can do what, or how the organisation works.
  'admin.users.manage',
  'admin.users.password_reset',
  'admin.users.two_factor_reset.request',
  'admin.users.two_factor_reset.approve',
  'admin.roles.manage',
  'admin.facilities.manage',
  'admin.organisation.manage',
  // Finance approvals: they change what patients owe or commit the facility's money.
  'billing.waiver.approve',
  'billing.credit_note.approve',
  'payments.refund.approve',
  'claims.write_off.approve',
  'insurance.write_off.approve',
  'revenue_share.approve',
  'procurement.approve',
  'procurement.invoice.approve',
  'stock.adjust.approve',
  'accounting.period.close',
  // How the facility's tax documents are signed (ADR 0041, plan V2).
  'etims.settings.manage',
  // Bulk patient import; its description already says two-factor roles only.
  'patients.import',
];

export const TWO_FACTOR_PERMISSIONS: ReadonlySet<string> = new Set(LIST);

export function permissionNeedsTwoFactor(permission: string): boolean {
  return TWO_FACTOR_PERMISSIONS.has(permission);
}

/** True when holders of the role must use two-factor sign-in, whatever its flag says. */
export function roleNeedsTwoFactor(role: {
  requires2fa: boolean;
  permissions: readonly string[];
}): boolean {
  return role.requires2fa || role.permissions.some(permissionNeedsTwoFactor);
}
